import { useContext, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppContext } from "../contexts/AppContext";

const Toaster = () => {
  const appContext = useContext(AppContext);

  useEffect(() => {
    if (!appContext.notification.show || !appContext.notification.type) return;
    const { type, message } = appContext.notification;
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.BOTTOM_LEFT,
          toastId: "success",
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.BOTTOM_LEFT,
          toastId: "error",
        });
        break;
      default:
        break;
    }
  }, [appContext.notification]);
  return (
    <ToastContainer
      position="bottom-left"
      autoClose={2000}
      className={"custom-toast"}
      toastClassName={({ type }) =>
        type === "error" ? "error-toast" : "success-toast"
      }
      hideProgressBar={true}
      icon={false}
      closeButton={false}
    />
  );
};

export default Toaster;
